const menuItems = [...document.querySelectorAll('[data-menu-item]')]
const pageRoot = document.querySelector('[data-root]') 

let cachedPages = {
  [window.location.href]: {
    markup: pageRoot.innerHTML,
    title: document.title,
    url: window.location.href
  }
}

const toggleClasses = (item) => {
  for(let i = 0; i < menuItems.length; i++){
    menuItems[i].parentNode.classList[menuItems[i] == item ? 'add' : 'remove']('active')
  }
}

const pageChanged = ({ title, markup, url }, pushState = true) => {
  pageRoot.innerHTML = markup
  document.title = title
  if(pushState) window.history.pushState({}, '', url)
}

const changePage = async (url) => {
  if(cachedPages[url]){
    return pageChanged(cachedPages[url])
  }

  const text = await fetch(url).then(r => r.text())
  const parser = new DOMParser()
  const html = parser.parseFromString(text, 'text/html')
  const pageContent = html.querySelector('[data-root]').innerHTML

  cachedPages[url] = {
    title: html.title,
    markup: pageContent,
    url
  }
  pageChanged(cachedPages[url])
}

menuItems.forEach(item => {
  item.addEventListener('click', e => {
    e.preventDefault()
    toggleClasses(item)
    changePage(item.href)
  })
})

window.onpopstate = e => {
  const menuItem = menuItems.find(i => i.href === window.location.href)
  if(menuItem) menuItem.click()
}